import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Modal,
    Box,
    Typography,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    IconButton,
    Grid,
    Card,
    CardContent,
    TextField,
    FormControl,
    Tabs,
    Tab
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { ChannelContext, CommonContext } from '../../context';
import commonApi from '../../utils/api';
import '../../assets/styles/AddModal.scss';

const AddChannel = () => {
    const { user, setOpenAlert, setAlertMessage,setSeverity, } = useContext(CommonContext);
    const location = useLocation();
    const merchantData = location?.state;
    const {
        addModal,
        handleCloseModal,
        setIsLoading,
        viewData,
        onLoadApi,
        isEdit,
        setIsEdit,
    } = useContext(ChannelContext);

    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        channel_type_id: '',
        channel_name: '',
        shopify_app_token: '',
        shopify_store_name: '',
        status: 1, // Default to Active
    });
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        if (tabValue === 0) {
            setFormData({ ...formData, channel_type_id: 1 });
        } else if (tabValue === 1) {
            setFormData({ ...formData, channel_type_id: 2 });
        }
    }, [tabValue]);

    useEffect(() => {
        if (viewData) {
            setFormData(viewData[0]);
            setTabValue(viewData[0].channel_type_id - 1);
        }
    }, [viewData]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        const errors = {};

        // Shopify validation
        if (tabValue === 0) {
            if (!formData.channel_name) errors.channel_name = 'Channel name is required';
        }

        setFormErrors(errors);

        let formDataToSend = { ...formData };
        if (user?.user_type === "Merchant") {
            formDataToSend.merchant_id = user?.id;
        } else if (merchantData?.id) {
            formDataToSend.merchant_id = merchantData.id;
        }

        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            const url = isEdit ? 'channel-integration/edit-channel-setup' : 'channel-integration/create-channel-setup';
            commonApi.post(url, formDataToSend)
                .then((response) => {
                    setIsEdit(false);
                    setIsLoading(false);
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.message);
                    setSeverity(response.data.s === 1 ? 'success' : 'error');
                    onLoadApi(formDataToSend.merchant_id);
                    handleCloseModal();
                })
                .catch((error) => {
                    setIsEdit(false);
                    setIsLoading(false);
                    setOpenAlert(true);
                    setAlertMessage(error?.response?.data?.message, error?.message || 'Something went wrong');
                    setSeverity('error');
                });
        }
    };

    return (
        <Modal open={addModal} size="lg">
            <Box className="add-modal">
                <Box className="modal-header">
                    <Typography variant="h6">{isEdit ? 'Edit' : 'Add'} Channel</Typography>
                    <IconButton onClick={handleCloseModal} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box className="content-body">
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="channel tabs" sx={{ mb: 2 }}>
                        <Tab label="Shopify" />
                        <Tab label="Woocommerce" />
                    </Tabs>
                    <form className="custom-form" onSubmit={handleSubmit} noValidate>
                        <Card className="form-section">
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            className="custom-input"
                                            label="Channel Name *"
                                            name="channel_name"
                                            value={formData.channel_name}
                                            onChange={handleChange}
                                            error={!!formErrors.channel_name}
                                            helperText={formErrors.channel_name}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            className="custom-input"
                                            label="App Token"
                                            name="shopify_app_token"
                                            value={formData.shopify_app_token}
                                            onChange={handleChange}
                                            error={!!formErrors.shopify_app_token}
                                            helperText={formErrors.shopify_app_token}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            className="custom-input"
                                            label="Store Name"
                                            name="shopify_store_name"
                                            value={formData.shopify_store_name}
                                            onChange={handleChange}
                                            error={!!formErrors.shopify_store_name}
                                            helperText={formErrors.shopify_store_name}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                            >
                                                <FormControlLabel
                                                    value={1}
                                                    control={<Radio />}
                                                    label="Active"
                                                />
                                                <FormControlLabel
                                                    value={0}
                                                    control={<Radio />}
                                                    label="Inactive"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </form>
                </Box>

                <Box className="form-actions">
                    <Button variant="outlined" onClick={handleCloseModal} color="error" type="button">
                        Cancel
                    </Button>
                    <Button variant="contained" color="success" type="submit" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddChannel;
